import type { Industry } from "../types";
import {
  RetailIcon,
  ManufacturingIcon,
  RealEstateIcon,
  HealthcareIcon,
  EducationIcon,
  HospitalityIcon,
  AutomobileIcon,
  JewelleryIcon,
} from "../components/icons/IndustryIcons";

export const industries: Industry[] = [
  { id: "retail", name: "Retail", Icon: RetailIcon },
  { id: "manufacturing", name: "Manufacturing", Icon: ManufacturingIcon },
  { id: "real-estate", name: "Real Estate", Icon: RealEstateIcon },
  { id: "healthcare", name: "Healthcare", Icon: HealthcareIcon },
  { id: "education", name: "Education", Icon: EducationIcon },
  { id: "hospitality", name: "Hospitality", Icon: HospitalityIcon },
  { id: "automobile", name: "Automobile", Icon: AutomobileIcon },
  { id: "jewellery-lifestyle", name: "Jewellery & Lifestyle", Icon: JewelleryIcon },
];
